import React from 'react';
import * as icons from '../Icons/file-icon';
import type { FileExtensionIconSharedProps } from './FileExtensionIcon.types';
import { fileExtensionsReferences } from './file-extensions-icons-config';

export type FileExtensionIconProps = React.ComponentProps<'svg'> & FileExtensionIconSharedProps;

/** The base names of the icon barrel's exports — `GenericIcon` contributes `Generic`. */
type IconBaseName = keyof typeof icons extends infer Name ? (Name extends `${infer Base}Icon` ? Base : never) : never;

/**
 * Typing the table here, rather than in the unsuffixed config, is what makes a misspelt value a
 * compile error: this is the first point that can see the platform's icon barrel. A wrong name used
 * to type-check and quietly render the generic icon, which is the bug this pairing exists to stop.
 */
const iconNames: Record<string, IconBaseName> = fileExtensionsReferences;

/** Maps a file extension string to the corresponding SVG icon. Falls back to a generic icon for unrecognised extensions. */
export const FileExtensionIcon = ({ extension, ...props }: FileExtensionIconProps) => {
  const fileExtensionName = iconNames[extension.toLowerCase()];
  const Icon = fileExtensionName ? icons[`${fileExtensionName}Icon`] : icons.GenericIcon;

  return <Icon data-testid={`${fileExtensionName || 'Default'} file extension icon`} {...props} />;
};
